import React from 'react';
import {isEmpty} from 'lodash';
import {Table, Input, Button} from 'semantic-ui-react';

const DisplayData = ({
  item,
  idx,
  handleUpdateAmount,
  handleUpdateObs,
  subcontractObject,
  handleRemoveItem,
  disabledBtns,
}) => {
  const {
    id,
    numInvoice,
    observation,
    totalDealer,
    totalTde,
    totalProvider,
    total,
  } = item;
  return (
    <Table.Row key={id}>
      <Table.Cell>{id}</Table.Cell>
      <Table.Cell>
        {isEmpty(subcontractObject) ? '' : subcontractObject[id].description}
      </Table.Cell>
      <Table.Cell>{numInvoice}</Table.Cell>
      <Table.Cell>
        <Input
          placeholder='Observación'
          value={observation || ''}
          disabled={disabledBtns}
          onChange={(e, {value}) => handleUpdateObs('observation', value, item)}
        />
      </Table.Cell>
      <Table.Cell>
        {'$'}
        {totalDealer || total}
      </Table.Cell>
      <Table.Cell>
        {'$'}
        {totalTde || total}
      </Table.Cell>
      <Table.Cell>
        <Input
          className='twc-subcontract-input'
          placeholder='Total Fabricante'
          value={totalProvider || 0}
          type='number'
          min='0'
          step='0.1'
          pattern='^\d+(?:\.\d{1,2})?$'
          disabled={disabledBtns}
          onChange={(e, {value}) => handleUpdateAmount('totalProvider', value, item)}
        />
      </Table.Cell>
      <Table.Cell>
        {'$'}
        {total}
      </Table.Cell>
      <Table.Cell>
        <Button
          disabled={disabledBtns}
          onClick={() => handleRemoveItem(idx)}
          size='mini'
          color='red'
        >
          Eliminar
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};
export default DisplayData;
